"use client";

import React from 'react';
import { cn } from '@/lib/utils';

interface CheckmarkProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Checkmark: React.FC<CheckmarkProps> = ({ className, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    className={cn("h-4 w-4 shrink-0", className)}
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M9.971.0001c.795.012 1.605.092 2.381.278.536.13.867.67.737 1.207-.129.536-.672.866-1.206.738-.621-.15-1.28-.213-1.906-.223-2.137.006-4.144.844-5.65 2.359C2.82 5.8741 1.994 7.8861 2 10.0231c.006 2.137.844 4.143 2.359 5.65 1.51 1.501 3.512 2.327 5.641 2.327h.023c2.137-.006 4.144-.844 5.65-2.359 1.507-1.516 2.333-3.527 2.327-5.664-.001-.552.445-1.002.997-1.003.554 0 1.002.446 1.0030461.997.0079539 2.671-1.0250461 5.186-2.9090461 7.08-1.883 1.894-4.391 2.941-7.062 2.949H10c-2.661 0-5.164-1.032-7.051-2.909-1.894-1.883-2.941-4.391-2.94904612-7.062C-.008 7.3571 1.025 4.8431 2.909 2.9491 4.792 1.0551 7.3.0081 9.971.0001zm6.277 4.3409c.364-.413.995-.457 1.411-.093.415.363.457.995.093 1.411l-7 8c-.182.208-.442.331-.719.341H10c-.265 0-.519-.105-.707-.293l-3-3c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l2.244 2.244z'/>
  </svg>
);

export default Checkmark;